import React from "react";
import { Card, CardContent, Typography, Chip, Grid, Box } from "@mui/material";
import { Build as SkillsIcon } from "@mui/icons-material";
import sharedStyles from "./sharedStyles";

interface CandidateSkillsProps {
  candidateData: {
    skills: string[];
  };
}

const CandidateSkills: React.FC<CandidateSkillsProps> = ({ candidateData }) => {
  const { skills } = candidateData;

  return (
    <Card sx={{ ...sharedStyles.card }} data-testid="candidate-skills">
      <CardContent>
        <Box sx={sharedStyles.title}>
          <SkillsIcon sx={sharedStyles.smallIcon} />
          <Typography variant="h6" fontWeight="bold">
            Skills
          </Typography>
        </Box>
        <Box
          sx={{
            ...sharedStyles.scrollableContainer,
            maxHeight: "120px",
            p: 2,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              flexWrap: "wrap",
            }}
          >
            {skills.length > 0 ? (
              skills.map((skill) => (
                <Grid item key={skill}>
                  <Chip
                    key={skill}
                    label={skill}
                    size="small"
                    sx={{
                      backgroundColor: "#EEF4FE",
                      color: "#3b82f6",
                      fontWeight: "500",
                      fontSize: "0.875rem",
                      height: "28px",
                      borderRadius: "6px",
                      '&:hover': {
                        backgroundColor: "#DCE7FD",
                      },
                    }}
                  />
                </Grid>
              ))
            ) : (
              <Typography variant="body2" sx={sharedStyles.infoLabel}>
                No skills available.
              </Typography>
            )}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CandidateSkills;